export default "__VITE_ASSET__AwwXSFa$__"